import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Toast } from 'react-vant'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { useSendCode } from '@/hooks/useSendCode'
import { APIWeb } from '@/api'
import { useTransactionRefresh } from '@/hooks'

export default React.memo(function LoginVerifyCode() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { sendCodeLoading, sendCode } = useSendCode()
  const { refreshAfterTransaction } = useTransactionRefresh()
  const [submitLoading, setSubmitLoading] = useState(false)

  // 从路由状态中获取手机号
  const account = state?.account || ''

  // 重新发送验证码
  const handleResendCode = async () => {
    await sendCode({ account, scene: 'register' })
  }

  // 提交验证码 - 调用登录接口，password 传空
  const handleSubmit = async (code: string) => {
    if (!account || !code) {
      Toast.fail(t('请输入验证码'))
      return
    }

    setSubmitLoading(true)
    try {
      const data = await APIWeb.login({
        account,
        password: '', // 手机号登录 password 传空
        code, // 传递验证码
      })

      // 保存 token
      if (data?.token) {
        localStorage.setItem('token', data.token)
        await refreshAfterTransaction()

        Toast.success({
          message: t('登录成功'),
          duration: 1500,
          onClose: () => {
            navigate('/home', { replace: true })
          }
        })
      }
    } catch (error: any) {
      console.error('登录失败:', error)
    } finally {
      setSubmitLoading(false)
    }
  }

  return (
    <PageLayout>
      <Header 
        leftChildren={<Back />} 
        centerChildren={<div className='text-3.75 font-medium text-black'>{t('验证')}</div>} 
      />
      <div className="flex-1 overflow-y-auto px-6 py-6">
        <VerificationCodeInput
          account={account}
          onResendCode={handleResendCode}
          onSubmit={handleSubmit}
          resendLoading={sendCodeLoading}
          submitLoading={submitLoading}
          submitButtonText={t('确认')}
        />
      </div>
    </PageLayout>
  )
})
